
import React from 'react'

import Reset from './reset';
import Theme from './theme';

export default () => <>
  <Reset/>
  <Theme/>
</>
